module.exports = __webpack_public_path__ + "static/media/Montserrat-Thin.78770905.woff";